import styled from 'styled-components';

export const _FullPageContainer = styled.div`
  display: flex;
  height: 100vh;
  min-height: 100vh;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 60px 15px;
  z-index: 999;
`;

export const _Title = styled.h1`
  font-size: 28px;
  margin-bottom: 15px;
  font-family: aktiv-grotesk, sans-serif;
  font-weight: 500;
  color: ${(props) => props.theme.primary};
  text-align: left;
  text-transform: uppercase;
  margin-top: 36px;
  text-align: center;
`;
